import { appThemeColors } from "styles/appTheme";
import { appThemeFonts } from "styles/appThemeFonts";
import { appThemeSize, appThemeSpace } from "styles/appThemeTokens";
import { getChevronRotatedSx, menuItemSx, menuTitleSx } from "../TopHeader.style";

export { getChevronRotatedSx };

export const userMenuWidthSx = {
  width: appThemeSize.menuWidthLg,
};

export const userInfoBlockSx = {
  padding: `${appThemeSpace.lg} ${appThemeSpace.xl} ${appThemeSpace.xl}`,
  borderBottom: `1px solid ${appThemeColors.background.soft}`,
};

export const userNameSx = {
  ...menuTitleSx,
};

export const userEmailSx = {
  fontFamily: appThemeFonts.family.ui,
  fontSize: appThemeFonts.size.md,
  color: appThemeColors.text.muted,
  marginTop: "3px",
};

export const userPhoneSx = {
  fontFamily: appThemeFonts.family.numeric,
  fontSize: appThemeFonts.size.md,
  color: appThemeColors.text.muted,
  marginTop: appThemeSpace.sm,
};

export const expanderButtonSx = {
  ...menuItemSx,
  padding: `9px ${appThemeSpace.lg}`,
};

export const expanderButtonTopSx = {
  ...expanderButtonSx,
  marginTop: appThemeSpace.xs,
};

export const rolesListSx = {
  padding: `${appThemeSpace.xxs} ${appThemeSpace.lg} ${appThemeSpace.md} 36px`,
  fontFamily: appThemeFonts.family.ui,
  fontSize: appThemeFonts.size.mdPlus,
  color: appThemeColors.text.muted,
  lineHeight: appThemeFonts.lineHeight.relaxed,
};

export const nestedActionSx = {
  ...menuItemSx,
  padding: `${appThemeSpace.md} ${appThemeSpace.lg} ${appThemeSpace.md} 36px`,
  fontSize: appThemeFonts.size.mdPlus,
};
